import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enAuth from './locales/en/auth.json';
import enNav from './locales/en/nav.json';
import enHome from './locales/en/home.json';
import enFooter from './locales/en/footer.json';
import enRules from './locales/en/rules.json';
import enPrisoner from './locales/en/prisoner.json';
import enActivation from './locales/en/activation.json';
import enMinter from './locales/en/minter.json';
import enAgent from './locales/en/agent.json';
import enStory from './locales/en/story.json';
import enDBChain from './locales/en/dbchain.json';
import enCharacterGallery from './locales/en/characterGallery.json';

// Import Chinese translations
import zhCNCommon from './locales/zh-CN/common.json';
import zhCNDashboard from './locales/zh-CN/dashboard.json';
import zhCNAuth from './locales/zh-CN/auth.json';
import zhCNNav from './locales/zh-CN/nav.json';
import zhCNHome from './locales/zh-CN/home.json';
import zhCNFooter from './locales/zh-CN/footer.json';
import zhCNRules from './locales/zh-CN/rules.json';
import zhCNPrisoner from './locales/zh-CN/prisoner.json';
import zhCNActivation from './locales/zh-CN/activation.json';
import zhCNMinter from './locales/zh-CN/minter.json';
import zhCNAgent from './locales/zh-CN/agent.json';
import zhStory from './locales/zh-CN/story.json';
import zhDBChain from './locales/zh-CN/dbchain.json';
import zhCharacterGallery from './locales/zh-CN/characterGallery.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          common: enCommon,
          dashboard: enDashboard,
          auth: enAuth,
          nav: enNav,
          home: enHome,
          footer: enFooter,
          rules: enRules,
          prisoner: enPrisoner,
          activation: enActivation,
          minter: enMinter,
          agent: enAgent,
          story: enStory,
          dbchain: enDBChain,
          characterGallery: enCharacterGallery
        }
      },
      'zh-CN': {
        translation: {
          common: zhCNCommon,
          dashboard: zhCNDashboard,
          auth: zhCNAuth,
          nav: zhCNNav,
          home: zhCNHome,
          footer: zhCNFooter,
          rules: zhCNRules,
          prisoner: zhCNPrisoner,
          activation: zhCNActivation,
          minter: zhCNMinter,
          agent: zhCNAgent,
          story: zhStory,
          dbchain: zhDBChain,
          characterGallery: zhCharacterGallery
        }
      }
    },
    // 默认语言设置为英文，但会优先使用localStorage中存储的语言
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh-CN'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'], // 优先使用localStorage中存储的语言
      lookupLocalStorage: 'i18nextLng',     // localStorage中的键名
      caches: ['localStorage'],             // 确保使用localStorage进行缓存
      lookupFromPathIndex: 0,               // 从URL路径中查找语言代码的索引
      lookupFromSubdomainIndex: 0           // 从子域名中查找语言代码的索引
    },
    react: {
      useSuspense: false                    // 防止语言切换时的闪烁
    }
  });

export default i18n;
